import { custom } from 'devextreme/ui/dialog';


export default async function showErrorDialog(options) {
    options.okButton = options.okButton||"Ok";
  
    const dlg = custom({
      showTitle: false,
      messageHtml: `
        <div class="aim2-confirm-dialog-title">
          ${options.title}
        </div>
        <div class="aim2-confirm-dialog-message">
          ${options.message}
        </div>
      `,
      buttons: [{
        text: options.okButton,
        type: options.btnType || "default",
        onClick: () => false
      }]
    });
    return dlg.show();
  }
  